export default "__VITE_ASSET__DWgwPC6e__"